// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fee-schedule-form{display:flex;flex-direction:column;padding:1em}.fee-schedule-form .ui-date-field{width:unset}.fee-schedule-form__date-fields{display:flex;flex-flow:row wrap}.fee-schedule-form__buttons{display:flex;flex-flow:row wrap}.fee-schedule-form__button{margin-right:1em;margin-bottom:1em}", ""]);
// Exports
module.exports = exports;
